const NeutralRoute = ({ children }: { children: JSX.Element }) => {
  return children;
};
export default NeutralRoute;
